import { matchPath, useLocation } from 'react-router';

import { SIZE_CONSTRAINT_EXEMPT_ROUTES } from '../../layout/constants.ts';
import { selectDeviceWidth } from '../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { DeviceWidth } from '../../redux/types.ts';

export const useIsScreenSupported = (supportedScreens: DeviceWidth[]): boolean => {
  const deviceWidth = useAppSelector(selectDeviceWidth);
  const { pathname } = useLocation();

  const routeIsExempt = Boolean(
    SIZE_CONSTRAINT_EXEMPT_ROUTES.find((route) => matchPath(route, pathname)),
  );

  if (routeIsExempt) return true;

  return supportedScreens.includes(deviceWidth);
};
